var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 2H9.8C13 2 15 4 15 7.2V11.25H8.75C8.34 11.25 8 11.59 8 12C8 12.41 8.34 12.75 8.75 12.75H15V16.8C15 20 13 22 9.8 22H7.21C4.01 22 2.01 20 2.01 16.8V7.2C2 4 4 2 7.2 2Z",
    fill: "#E22626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4396 11.2498L17.3696 9.17984C17.2196 9.02984 17.1496 8.83984 17.1496 8.64984C17.1496 8.45984 17.2196 8.25984 17.3696 8.11984C17.6596 7.82984 18.1396 7.82984 18.4296 8.11984L21.7796 11.4698C22.0696 11.7598 22.0696 12.2398 21.7796 12.5298L18.4296 15.8798C18.1396 16.1698 17.6596 16.1698 17.3696 15.8798C17.0796 15.5898 17.0796 15.1098 17.3696 14.8198L19.4396 12.7498H14.9996V11.2498H19.4396Z",
    fill: "#E22626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.940a42f274d6de9b0c305338effb59d3.svg";
export { ForwardRef as ReactComponent };